<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Games from "@/services/Games";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    export default {
        props:['groupOptions'],
        components:{
            validationMessages, vueDropzone: vue2Dropzone, flatPickr
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                question:'',
                active_from:'',
                active_from_time:'',
                active_to:'',
                active_to_time:'',
                answers: [{ answer: "" }],
                min_answers: 0,
                image_url: null,
                recipient:'',
                selected_group_id:'',
                audienceOptions: [
                { value: 'ALL', text: 'All users' },
                { value: 'GROUP', text: 'User segment(group)' },
              ],
                photoDeletedCompanyImage : false ,
                photoDeletedLogoUrl : false ,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                verified_checked: true,
                datetimeconfig: {
                  enableTime: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "Y-m-d H:i:S",
                },
                dropzoneOptions_primary: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 4,
                    acceptedFiles: 'image/jpeg,image/png,image/bmp,image/webp',
                    maxFiles: 3,
                },
                dateconfig: {
                  enableTime: false,
                  dateFormat: "Y-m-d",
                  minDate: new Date(),
                },
                timeconfig: {
                  enableTime: true,
                  noCalendar: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "H:i",
                },
            };
        },
        validations: {
           question:{
             required
           },
          active_from:{
             required
          },
          active_from_time:{
             required
          },
          active_to:{
             required
          },
          active_to_time:{
            required
          },
          recipient:{
            required
          },
         
        },
        computed:{
          hasGroupSelection() {
            return this.recipient === 'GROUP'
          },
        },

        methods: {
          openDatePicker() {
            this.$refs.datePicker.$el.click();
          },
          openTimePicker() {
            this.$refs.timePicker.$el.click();
          },
          addAnswerField(){
              this.answers.push({ answer: "" });
          },
          removeAnswerField(index){
            if(this.answers.length === 1) return;
            this.answers.splice(index, 1);
          },

            async addPoll(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {
                      if (this.answers[0].answer === ''){
                        this.answers = {}
                      }
                      let selecteGroup = '';

                      if(this.hasGroupSelection){
                        selecteGroup = this.selected_group_id
                      }else{
                        selecteGroup = ''
                      }

                        await Games.addPoll({
                            question: this.question,
                            active_from: `${this.active_from} ${this.active_from_time}:00`,
                            active_to: `${this.active_to} ${this.active_to_time}:00`,
                            answers: this.answers,
                            min_answers: this.min_answers,
                            image: this.image_url,
                            recipient: this.recipient,
                            group_id:selecteGroup,
                            csrf_token: this.csrf_token
                        }).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },

            selectFileImageUrl(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_image_url.getQueuedFiles();
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only have one logo url');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_image_url.removeFile(value);
                        });

                    }
                    this.image_url = queuedFiles[0] || null;
                    this.photoDeletedLogoUrl = false;
                }, 250);
            },

            refreshData() {
                this.$emit('onRefresh')
            },
            closeModal() {
                this.showModal = false
                this.resetProps()
            },
            resetProps(){
                this.question = ''
                this.active_from = ''
                this.active_from_time = ''
                this.active_to = ''
                this.active_to_time = ''
                this.answers = [{ answer: "" }]
                this.min_answers = 0
                this.image_url = null
                this.submitted = false
                this.recipient = '';
                this.selected_group_id = '';
            }
        },
    };
</script>

<template>
    <b-modal v-model="showModal" @hidden="resetProps"  id="add_new_poll" title="Add new Poll Question and Answers" title-class="font-18" size="lg" centered>

      <template v-slot:modal-header>
        <div class="w-100">
          <h5 class="modal-title mb-0">Add New Poll</h5>
          <p class="text-muted mb-0 mt-2">Add new Poll Question and Answers</p>
        </div>
        <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
      </template>

        <form @submit.prevent="addPoll">

        <div class="card mb-3">
          <div class="card-body py-3">
          <header >
            <h4 class="card-title">Recipients</h4>
            <p class="text-muted mb-3">Choose who can see this poll</p>
          </header>

          <b-form-group
            label="Target audience *"
            label-for="giveaway-target-audience"
            class="mb-0"
          >
            <b-form-select
              id="giveaway-target-audience"
              v-model="recipient"
              :options="audienceOptions"
              :class="{
                'is-invalid': submitted && $v.recipient.$error,
              }"
            />
           <validationMessages v-if="submitted" :fieldName="'Target audience'" :validationName="$v.recipient">
            </validationMessages>
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment *"
            class="mt-4 mb-0"
          >
            <b-form-select
              v-model="selected_group_id"
              :options="groupOptions"
              placeholder="Select user segment"
            />
          </b-form-group>
          </div>
         
        </div>


          <div class="card mb-3">
            <div class="card-body py-3">
              <h4 class="card-title mb-1">Poll Question</h4>
              <p class="text-muted mb-3">Enter your poll question and select the date and time</p>
                <b-form-group label-for="formrow-external-input" class="mb-3">
                  <label for="name">Poll Question*</label>
                  <b-form-input
                      v-model.trim="question"
                      type="text"
                      id="question"
                      aria-describedby="question-feedback"
                      :class="{
                        'is-invalid': submitted && $v.question.$error,
                      }"
                  >
                  </b-form-input>
                  <validationMessages v-if="submitted" :fieldName="'Poll Question'" :validationName="$v.question"></validationMessages>
                </b-form-group>

                <div class="row">
                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-calendar-alt me-1"></i>Active From Date*
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="datePickerFrom"
                          v-model="active_from"
                          :config="dateconfig"
                          class="form-control pe-4"
                          name="date"
                          :class="{
                              'is-invalid': submitted && $v.active_from.$error,
                          }"
                      />
                      <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openDatePicker"></i>
                    </div>
                    <validationMessages
                        v-if="submitted"
                        :fieldName="'Active From'"
                        :validationName="$v.active_from"
                    ></validationMessages>
                  </div>
                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-clock me-1"></i>Active From Time *
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="timePicker"
                          v-model="active_from_time"
                          :config="timeconfig"
                          class="form-control pe-4"
                          name="time"
                          :class="{
                              'is-invalid': submitted && $v.active_from_time.$error,
                          }"
                      />
                      <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openTimePicker"></i>
                      <validationMessages
                          v-if="submitted"
                          :fieldName="'Active From Time'"
                          :validationName="$v.active_from_time"
                      ></validationMessages>
                    </div>
                  </div>
                </div>
                      <!-- DATE/TIME TO  -->
                <div class="row">
                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-calendar-alt me-1"></i>Active To Date*
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="datePickerTo"
                          v-model="active_to"
                          :config="dateconfig"
                          class="form-control pe-4"
                          name="date"
                          :class="{
                              'is-invalid': submitted && $v.active_to.$error,
                          }"
                      />
                      <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openDatePicker"></i>
                    </div>
                    <validationMessages
                        v-if="submitted"
                        :fieldName="'Active To'"
                        :validationName="$v.active_to"
                    ></validationMessages>
                  </div>

                  <div class="col-6">
                    <label class="mb-1">
                      <i class="uil uil-clock me-1"></i>Active To Time *
                    </label>
                    <div class="position-relative">
                      <flat-pickr
                          ref="timePicker"
                          v-model="active_to_time"
                          :config="timeconfig"
                          class="form-control pe-4"
                          name="time"
                          :class="{
                              'is-invalid': submitted && $v.active_to_time.$error,
                          }"
                      />
                      <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                         style="cursor: pointer; pointer-events: all;"
                         @click="openTimePicker"></i>
                      <validationMessages
                          v-if="submitted"
                          :fieldName="'Active To Time'"
                          :validationName="$v.active_to_time"
                      ></validationMessages>
                    </div>
                  </div>

                </div>
            </div>
          </div>

          <div class="card mb-3">
            <div class="card-body py-3">
              <div class="d-flex align-items-center justify-content-between">
                <label class="form-label">
                  <h4 class="card-title mb-1">Poll Answers</h4>
                  <p class="text-muted mb-3">Add Answers to the Poll</p>
                </label>
                <b-button size="sm" class="w-20" style="position: relative; bottom: 5px" variant="outline-primary" @click.prevent="addAnswerField">+ Add Poll Answer</b-button>
              </div>

              <div v-for="(answer, index) in answers" :key="index" class="mb-3 border rounded-3">
                <div class="d-flex align-items-start gap-2">
                  <b-form-input
                      v-model.trim="answer.answer"
                      type="text"
                      :id="'answer-' + index"
                  >
                  </b-form-input>
                  <b-button
                      v-if="answers.length > 1"
                      variant="outline-danger"
                      class="ms-2"
                      @click.prevent="removeAnswerField(index)"
                      title="Remove this answer">
                    <i class="uil uil-trash-alt"></i>
                  </b-button>
                </div>
              </div>

            </div>
          </div>

<!--          <div class="card mb-3">
            <div class="card-body py-3">
              <b-form-group label-for="formrow-external-input" class="mt-3">
                <label for="name">Minimum Number of Answers</label>
                <b-form-input
                    v-model.trim="min_answers"
                    type="number"
                    id="min_answers"
                    aria-describedby="question-feedback"
                >
                </b-form-input>
                <p class="font-size-13 mt-1"><i class="uil-info-circle me-1"></i>Poll statistics are calculated after this minimum number of answers by participants is reached</p>
              </b-form-group>
            </div>
          </div>-->

          <div class="card mb-3">
            <div class="card-body py-3">
              <div class="form-group" >
                <label for="image_url"><i class="uil uil-image me-2"></i>Poll Image: (Max size:4 MB)</label>
                <template>
                  <vue-dropzone
                      id="image_url"
                      ref="myVueDropzone_image_url"
                      :use-custom-slot="true"
                      :options="dropzoneOptions_primary"
                      @vdropzone-files-added="selectFileImageUrl"
                      no-progress-bar
                  >
                    <div class="dropzone-custom-content">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                      <h4>Drag and drop an image, or click to browse</h4>
                      <div class="text-muted mb-3" style="font-size: 13px;">
                        PNG, JPEG, BMP, WEBP up to 4MB
                      </div>
                    </div>
                  </vue-dropzone>
                </template>

              </div>
            </div>
          </div>

          <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addPoll" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>
        </template>
    </b-modal>
</template>